// Hover intent: the open delay keeps a pointer passing over a tab from opening
// its menu. Once a menu is open, moving to another tab switches immediately.
export const HOVER_OPEN_DELAY_MS = 100
export const HOVER_SWITCH_DELAY_MS = 0

// The menu closes only after the pointer has stayed outside the tab + panel
// (grown by the padding) for the close delay without heading back toward it.
export const HOVER_CLOSE_DELAY_MS = 300
export const HOVER_ZONE_PADDING_PX = 8

// Pointer aim: recent pointer positions decide whether the pointer is moving
// toward the open panel. Older samples than the stale window mean it stopped.
export const POINTER_TRAIL_LENGTH = 4
export const POINTER_AIM_STALE_MS = 150

export const ITEM_KINDS = {
  link: 'link',
  sectionLabel: 'sectionLabel',
}
